import { render, staticRenderFns } from "./Assurance.vue?vue&type=template&id=f7caf8cc"
import script from "./Assurance.vue?vue&type=script&lang=js"
export * from "./Assurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports